import { YearlyTrends } from '@sly/core/src/types';

import { LineChartDataType } from '../types/charts';

export const getMonthlyMedianPrices = (
  data: YearlyTrends
): LineChartDataType => {
  return Object.entries(data).map(([year, price]) => ({
    year: parseInt(year),
    price,
  }));
};
